// Reviews shown on the session checkout, one at a time beside the Pay button.
//
// `reviews` is for REAL feedback only, shared with the person's permission.
// Once it has entries, they are shown everywhere (development and production).
// With no real reviews, the live site simply shows none.
//
// `placeholderReviews` are made-up samples to preview the layout. They are only
// shown in development builds and never on the live site, because fake reviews
// on a payment page would mislead customers.
//
// Shape: { name, role, quote, rating (1-5), avatar? (image URL) }

export const reviews = [];

export const placeholderReviews = [
  { name: 'Ananya R.', role: 'Final-year CSE student', rating: 5, quote: 'I was about to buy two more courses. The call showed me I only needed DSA practice and one solid project.' },
  { name: 'Karthik M.', role: 'SDE-1, service company', rating: 5, quote: 'Got a clear 3-month plan to move to a product company, with exactly what to skip. Worth every rupee.' },
  { name: 'Priya S.', role: 'Fresher, job hunting', rating: 5, quote: 'The CV review alone changed my callbacks. They rewrote my project points the way recruiters read them.' },
  { name: 'Rahul V.', role: 'Backend developer, 2 yrs', rating: 4, quote: 'Honest feedback on where I stand for system design rounds. No upselling, just a plan.' },
  { name: 'Sneha K.', role: 'Switching from testing to dev', rating: 5, quote: 'I finally know the order to learn things in. Saved me months of jumping between tutorials.' },
  { name: 'Arjun P.', role: 'SDE-2, mid-tier product', rating: 5, quote: 'Mapped out what top-tier interviews expect at my level. Clear, practical and very specific.' },
  { name: 'Divya N.', role: 'MCA student', rating: 5, quote: 'Thirty minutes and I left with a week-by-week roadmap. Should have done this before buying anything.' },
  { name: 'Vikram T.', role: 'Full-stack developer, 1 yr', rating: 4, quote: 'They pointed out the gaps in my projects that interviewers would have caught. Very useful.' }
];
